import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& input": {
      width: "100%",
      height: 39,
      userSelect: "none",
      fontFamily: "iranSans",
      borderRadius: 5,
      boxShadow: "0 3px 31px 0 rgba(0, 0, 0, 0.15)",
      padding: "3px 15px",
      border: "none",
      fontSize: "14px",
      backgroundColor: "#fff",
      "&:focus": {
        outline: "none",
      },
    },
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
  },
  newRoot: {
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(0, 0, 0, 0.23) !important",
    },
    "& .MuiFormLabel-root.Mui-error": {
      color: "#000",
    },
    "& .MuiInputBase-root ": {
      borderRadius: 16,
    },
    "& .MuiFormLabel-root  ": {
      borderRadius: 16,
    },
    "& input": {
      borderRadius: 16,
      width: "100%",
      userSelect: "none",
      fontFamily: "iranSans",
      boxShadow: "0px 4px 10px rgba(30, 30, 30, 0.1)",
      border: "none",
      fontSize: "14px",
      "&:focus": {
        outline: "none",
      },
    },
    "&:focus": {
      outline: "none",
    },
  },
  root2: {
    flex: 1,
    "& input": {
      width: "100%",
      height: 30,
      userSelect: "none",
      fontFamily: "iranSans",
      borderRadius: 10,
      padding: "3px 15px",
      border: "none",
      fontSize: "14px",
      backgroundColor: "#e3e3e3",
      "&:focus": {
        outline: "none",
      },
    },
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
  },
}));
export default function TextFieldComponent({ setState, fontSize, ...rest }) {
  const classes = useStyles();
  const handleChange = (e) => {
    setState(e.target.value);
  };
  return (
    <TextField {...rest} onChange={handleChange} className={classes.root} />
  );
}
export function NewTextFieldComponent({ setState, fontSize, ...rest }) {
  const classes = useStyles();
  const handleChange = (e) => {
    setState(e.target.value);
  };
  return (
    <TextField
      variant="outlined"
      {...rest}
      onChange={handleChange}
      className={classes.newRoot}
    />
  );
}
export function TextFieldComponentFilter({ setState, fontSize, ...rest }) {
  const classes = useStyles();
  const handleChange = (e) => {
    setState(e.target.value);
  };
  return (
    <TextField {...rest} onChange={handleChange} className={classes.root2} />
  );
}
